import { RegisterOptions } from 'react-hook-form';

import { FieldWithOptionType } from '@/models/case-field.model';
import { FieldComponentTypeEnum } from '@/models/component-type.model';

export const maximums = {
  [FieldComponentTypeEnum.Text as FieldComponentTypeEnum]: 150,
  [FieldComponentTypeEnum.MultiLineText as FieldComponentTypeEnum]: 2000,
};

export const genRules = (data: FieldWithOptionType, required: boolean, t: (key: string) => string): RegisterOptions => {
  const { key, component_type, label } = data;

  switch (component_type) {
    case FieldComponentTypeEnum.Text:
      if (key === 'email') {
        return {
          validate: (value: string) => {
            if (required && !value) return `${label} ${t('webform.is_required')}`;
            const emailReg =
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(\.+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return emailReg.test(value) || t('webform.email.address_invalid');
          },
        };
      } else {
        return { maxLength: maximums[component_type] };
      }
    case FieldComponentTypeEnum.Numeric:
      return {
        validate: (value: string) => {
          if (!required && !value) return true;
          if (required && !value) return `${label} ${t('webform.is_required')}`;
          const typeReg = /^(0|[1-9]\d*)$/;
          if (!typeReg.test(value)) return t('webform.numeric.integer_invalid');

          const maximumReg = /^\d{1,16}$/;
          return maximumReg.test(value) || `${label} ${t('webform.numeric.maximum_invalid')}`;
        },
      };
    case FieldComponentTypeEnum.Decimal:
      return {
        validate: (value: string) => {
          if (!required && !value) return true;
          if (required && !value) return `${label} ${t('webform.is_required')}`;

          const typeReg = /^(0|(0|[1-9]\d*)\.\d+)$/;
          if (!typeReg.test(value)) return t('webform.decimal.decimal_invalid');

          const maximumReg = /^(0|\d{1,16}\.\d{1,8})$/;
          return maximumReg.test(value) || `${label} ${t('webform.decimal.maximum_invalid')}`;
        },
      };
    case FieldComponentTypeEnum.MultiLineText:
      return { maxLength: maximums[component_type] };
    case FieldComponentTypeEnum.Checkbox:
      return {
        validate: (value: boolean) => {
          if (!required) return true;
          return value || `${label} ${t('webform.is_required')}`;
        },
      };
    default:
      return {};
  }
};
